import {useEffect,useState} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {
	getClasses
} from '../liveClassesSlice'
import {
	envAwarePost,
	copyToClipboard,
} from '../../../util/util'
import {
	getPriceText
} from '../helpers'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js'
import {selectCurrencyById} from '../../settings/settingsSlice'

const getRegisterPaymentIntent = (class_id)=>(
	envAwarePost(
		'api/classes/api/',
		{action:'getRegisterPaymentIntent',class_id}
	)
)

const finalizeRegistration = (payment_intent_id) => envAwarePost(
	'/api/classes/api.php',
	{action:'finalizePaymentIntent',payment_intent_id}
)

const RegisterModal = ({show,onHide,selectedClass})=>{
	const elements = useElements()
	const stripe = useStripe()
	const dispatch = useDispatch()
	const [status,setStatus] = useState('idle')
	const acceptedCurrency = useSelector(state=>selectCurrencyById(state,selectedClass?.presentment_currency_id))

	const confirmPayment = () => stripe.confirmPayment({
		elements,
		confirmParams: {
			return_url: 'https://www.fitsw.com',
		},
		redirect:'if_required'
	})

	const handlePurchase = async (event) => {
		setStatus('pending')
		// Block native form submission.
		event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not loaded yet. Make sure to disable
			// form submission until Stripe.js has loaded.
			return;
		}

		
		confirmPayment()
		.then( res => {
			if(res.error) throw new Error(res.error.message)
			if(res.paymentIntent.status !== 'succeeded') throw new Error("Something went wrong. Please, try again")
			return finalizeRegistration(res.paymentIntent.id)
		}).then( res => {
			if(res.success==='1'){
				return dispatch(getClasses())
			}else{
				throw new Error(res.message)
			}
		}).then( res => {
			onHide()
			setStatus('idle')
		}).catch( err => {
			setStatus('idle')
			window.alert(err)
		})

	}
	const taxPercent = useSelector(state=>state.settings.app.tax_percent)
	const price = ((
		selectedClass?.advancedPricing == 1?
		selectedClass?.clientPrice:
		selectedClass?.price
	)*(1+taxPercent/100)).toFixed(2)
	return (
		<Modal 
			onHide={onHide}
			show={show}
			centered
		>
			<Modal.Header closeButton>
				<span>{selectedClass?.title}</span>
			</Modal.Header>
			<Modal.Body>
				<PaymentElement/>
				<div className="mt-3 d-flex justify-content-end">
					<Button 
						disabled={status==='pending'}
						variant="outline-primary"
						onClick={handlePurchase}
					>
						<span>Register</span>
						<span className="mx-1">
							{Boolean(selectedClass)&&
								`${String.fromCharCode(acceptedCurrency?.char_code)}${price} (${acceptedCurrency?.ISO})`
							}
						</span>
						{status==='pending'&&<Spinner className="ml-2" animation="border" size="sm"/>}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default RegisterModal